<template>
    <b-button-group :class="controlClass" :size="controlSize">
        <b-button
            v-for="(item, idx) in buttonsActions"
            :key="idx + 'buttons'"
            @click="item['action']()"
            v-b-tooltip.hover
            :variant="item.variant"
            :title="item.tooltip"
            :size="item.size"
        >
            <b-icon v-if="!!item.icon" :icon="item.icon"></b-icon>
            <span class="ml-2" v-if="!!item.text">{{ item.text }}</span>
        </b-button>

        <b-dropdown
            v-if="dropdownActions.length > 0"
            right
            :disabled="dropdownDisabled"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
        >
            <template #button-content>
                <b-icon icon="three-dots"></b-icon>
            </template>
            <template v-for="(item, idx) in dropdownActions">
                <b-dropdown-header
                    :key="idx + 'dropdown-header'"
                    id="dropdown-header-label"
                    v-if="!!item.divider"
                >
                    {{ item.text }}
                </b-dropdown-header>
                <b-dropdown-item
                    v-if="!item.divider"
                    :key="idx + 'dropdown-item'"
                    @click="item['action']()"
                    :disabled="item.disabled"
                    >{{ item.text }}</b-dropdown-item
                >
            </template>
        </b-dropdown>
    </b-button-group>
</template>

<script>
export default {
    props: {
        buttonsActions: {
            type: Array,
            default: () => [],
        },
        dropdownTitle: {
            type: String,
            default: '',
        },
        dropdownActions: {
            type: Array,
            default: () => [],
        },
        dropdownDisabled: {
            type: Boolean,
            default: false,
        },
        controlClass: { type: String, default: 'float-right' },
        controlSize: { type: String, default: 'sm' },
    },
}
</script>

<style>
</style>